<template>
  <div class="">
    <search-group title="成交确认单查询" :multipleLines="true" :inline="true" :span="24" :btnOffset="18" :btnSpan="6" @search="findData" @clear="clearValue">
      <Row class="mb16" :gutter="16">
        <Col span="6">
        <Select placeholder="项目名称" v-model="searchData.projectFid">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="6">
        <DatePicker v-model="confirmTime" split-panels type="daterange" format="yyyy-MM-dd"   placeholder="确认日期" @on-change="getConfirmTime"></DatePicker>
        </Col>
        <Col span="6">
        <DatePicker v-model="createTime" split-panels type="daterange" format="yyyy-MM-dd"   placeholder="创建日期" @on-change="getCreateTime"></DatePicker>
        </Col>
        <Col span="6">
        <DatePicker v-model="signDate" split-panels type="daterange" format="yyyy-MM-dd"   placeholder="合同签约日期" @on-change="getSignDate"></DatePicker>
        </Col>
      </Row>
      <Row class="mb16" :gutter="16">
        <Col span="3">
        <Select placeholder="确认单状态" v-model="searchData.status">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in statusList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="3">
        <Input class="block" v-model.trim="searchData.monthPrice"  @keyup.enter.native="findData" placeholder="平台服务费，月租金，总租金"/>
        </Col>
        <Col span="8">
        <Input class="block" v-model.trim="searchData.searchInfo"  @keyup.enter.native="findData" placeholder="签约人、房间号、合同号、客户姓名、客户手机号"/>
        </Col>
      </Row>
    </search-group>
</div>
</template>

<script>
  import { getProjects } from 'api/common'
  import {getConfirmOrderStatus} from "../../../api/confirmOrder";
  export default {
    name: "SearchList",
    components: {
      // SearchGroup
    },
    data() {
      return {
        projectList: [],
        statusList:[],
        signDate:[],
        createTime:[],
        confirmTime:[],
        searchData: {}
      };
    },
    methods: {
      findData() {
        this.$emit("findData", this.searchData);
      },
      clearValue() {
        this.searchData= {
        }
        this.createTime = []
        this.confirmTime = []
        this.signDate = []
      },
      getConfirmTime(val){
        this.searchData.confirmTimeStart = val[0]
        this.searchData.confirmTimeEnd = val[1]
      },
      getCreateTime(val){
        this.searchData.createTimeStart = val[0]
        this.searchData.createTimeEnd = val[1]
      },
      getSignDate(val){
        this.searchData.signStartDate = val[0]
        this.searchData.signEndDate = val[1]
      },
    },
    created() {
      getProjects().then(res => {
        res.data && ( this.projectList = res.data)
      }).catch(error => {
      })
      getConfirmOrderStatus().then(res=>{
          res.data &&(this.statusList = res.data)
      }).catch(error=>{

      })
    }
  };
</script>
<style scoped>
  dash {
    text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 60%;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }
  .ivu-date-picker {
    width: 100%;
  }
</style>
